import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import "../styles/main.css";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MiniResourceCard = makeShortcode("MiniResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <MiniResourceCard slots="image,heading,text,link" repeat="24" theme="light" inRow="3" className="trending-cards" mdxType="MiniResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/0d85ea898605880ac5078a4d8cd8cabe/e72e6/google-drive.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/0d85ea898605880ac5078a4d8cd8cabe/2aa01/google-drive.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/0d85ea898605880ac5078a4d8cd8cabe/2aa01/google-drive.jpg",
            "alt": "Google Drive",
            "title": "Google Drive",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "google-drive"
    }}>{`Google Drive`}</h3>
    <p>{`Connect to Google Drive`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=wkn4094g6"
      }}>{`Google Drive`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/a5915a0e6b65d32fe6383436312156a0/e72e6/google-photos.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/a5915a0e6b65d32fe6383436312156a0/2aa01/google-photos.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/a5915a0e6b65d32fe6383436312156a0/2aa01/google-photos.jpg",
            "alt": "Google Photos",
            "title": "Google Photos",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "google-photos"
    }}>{`Google Photos`}</h3>
    <p>{`Connector to Google Photos`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w51k5ghig"
      }}>{`Google Photos`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/bb29e80bfc1d161c37284c8fb9f0a077/e72e6/one-drive.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/bb29e80bfc1d161c37284c8fb9f0a077/2aa01/one-drive.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/bb29e80bfc1d161c37284c8fb9f0a077/2aa01/one-drive.jpg",
            "alt": "OneDrive",
            "title": "OneDrive",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "onedrive"
    }}>{`OneDrive`}</h3>
    <p>{`Connect to Microsoft OneDrive`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w1n2h1lgm"
      }}>{`OneDrive`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/557bae91bf9c200586c0597227dc28b3/e72e6/drop-box.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/557bae91bf9c200586c0597227dc28b3/2aa01/drop-box.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/557bae91bf9c200586c0597227dc28b3/2aa01/drop-box.jpg",
            "alt": "Dropbox",
            "title": "Dropbox",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "dropbox"
    }}>{`Dropbox`}</h3>
    <p>{`Connect to Dropbox`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=wh0nlii37"
      }}>{`Dropbox`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/f9ff14e4e245ea355f57ce0624f0643c/e72e6/music-ai.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/f9ff14e4e245ea355f57ce0624f0643c/2aa01/music-ai.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/f9ff14e4e245ea355f57ce0624f0643c/2aa01/music-ai.jpg",
            "alt": "Genre X Music AI",
            "title": "Genre X Music AI",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "genre-x-music-ai"
    }}>{`Genre X Music AI`}</h3>
    <p>{`Create wonderful music for your content with AI`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w91620527"
      }}>{`Genre X Music AI`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/edab9d72f98abbdf5657c379e14c221b/e72e6/audio-stock.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/edab9d72f98abbdf5657c379e14c221b/2aa01/audio-stock.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/edab9d72f98abbdf5657c379e14c221b/2aa01/audio-stock.jpg",
            "alt": "Audiostock",
            "title": "Audiostock",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "audiostock"
    }}>{`Audiostock`}</h3>
    <p>{`Elevate Your Content with Royalty- Free Music / SFX`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w072hm543"
      }}>{`Audiostock`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "540px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/e9cd32586927f0208e6d1ca9ba2362fc/dda86/voice-over.webp 265w", "/express/add-ons/static/e9cd32586927f0208e6d1ca9ba2362fc/010e6/voice-over.webp 530w", "/express/add-ons/static/e9cd32586927f0208e6d1ca9ba2362fc/caa95/voice-over.webp 540w"],
            "sizes": "(max-width: 540px) 100vw, 540px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/e9cd32586927f0208e6d1ca9ba2362fc/35d86/voice-over.jpg 265w", "/express/add-ons/static/e9cd32586927f0208e6d1ca9ba2362fc/7d9a0/voice-over.jpg 530w", "/express/add-ons/static/e9cd32586927f0208e6d1ca9ba2362fc/ceaae/voice-over.jpg 540w"],
            "sizes": "(max-width: 540px) 100vw, 540px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/e9cd32586927f0208e6d1ca9ba2362fc/ceaae/voice-over.jpg",
            "alt": "Forge the path to customer success",
            "title": "Forge the path to customer success",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "voice-over"
    }}>{`Voice Over`}</h3>
    <p>{`Instantly add high quality voiceovers`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w98173m30"
      }}>{`Voice Over`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/c0d3e392a98091c77d8fe606f142d05f/e72e6/free-stock-search.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/c0d3e392a98091c77d8fe606f142d05f/2aa01/free-stock-search.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/c0d3e392a98091c77d8fe606f142d05f/2aa01/free-stock-search.jpg",
            "alt": "Free Stock Search",
            "title": "Free Stock Search",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "free-stock-search"
    }}>{`Free Stock Search`}</h3>
    <p>{`Millions of Free Stock Files in Adobe Express`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=wj6ji4ig0"
      }}>{`Free Stock Search`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/741ac403858d7d6f432a291d8fde4fc3/e72e6/ai-voice-over.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/741ac403858d7d6f432a291d8fde4fc3/2aa01/ai-voice-over.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/741ac403858d7d6f432a291d8fde4fc3/2aa01/ai-voice-over.jpg",
            "alt": "AiVOOV AI Voiceover",
            "title": "AiVOOV AI Voiceover",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "aivoov-ai-voiceover"
    }}>{`AiVOOV AI Voiceover`}</h3>
    <p>{`Convert your text to speech using AI voices`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w009nmmi8"
      }}>{`AiVOOV AI Voiceover`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/c205de15390a177c745ebe74d6cfe850/e72e6/image-animate.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/c205de15390a177c745ebe74d6cfe850/2aa01/image-animate.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/c205de15390a177c745ebe74d6cfe850/2aa01/image-animate.jpg",
            "alt": "Image Animate",
            "title": "Image Animate",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "image-animate"
    }}>{`Image Animate`}</h3>
    <p>{`Transform photos to videos in Adobe Express`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=whj5556m0"
      }}>{`Image Animate`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/963fd29449ee476de5db8f90f97a151a/e72e6/qr-designer.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/963fd29449ee476de5db8f90f97a151a/2aa01/qr-designer.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/963fd29449ee476de5db8f90f97a151a/2aa01/qr-designer.jpg",
            "alt": "QR Designer",
            "title": "QR Designer",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "qr-designer"
    }}>{`QR Designer`}</h3>
    <p>{`Customized QR codes for Adobe Express documents`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w7i3g2824"
      }}>{`QR Designer`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/53aaec931a4ba6ab8665caf51e594abb/e72e6/gradients.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/53aaec931a4ba6ab8665caf51e594abb/2aa01/gradients.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/53aaec931a4ba6ab8665caf51e594abb/2aa01/gradients.jpg",
            "alt": "Gradients",
            "title": "Gradients",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "gradients"
    }}>{`Gradients`}</h3>
    <p>{`Create linear, radial and conic gradients`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w51096n14"
      }}>{`Gradients`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/61494cf45bafaeac52b9ec3323f3ce82/e72e6/tittok.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/61494cf45bafaeac52b9ec3323f3ce82/2aa01/tittok.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/61494cf45bafaeac52b9ec3323f3ce82/2aa01/tittok.jpg",
            "alt": "TikTok",
            "title": "TikTok",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "tiktok-symphony-assistant"
    }}>{`TikTok Symphony Assistant`}</h3>
    <p>{`Discover TikTok inspiration, insights and music`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w4lmk8l67"
      }}>{`TikTok Symphony Assistant`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/376475068faf7d9af08929a2fc025b24/e72e6/gen-qr.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/376475068faf7d9af08929a2fc025b24/2aa01/gen-qr.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/376475068faf7d9af08929a2fc025b24/2aa01/gen-qr.jpg",
            "alt": "Gen QR",
            "title": "Gen QR",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "gen-qr"
    }}>{`Gen QR`}</h3>
    <p>{`Turn your QR codes vibrant and colorful`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w801n8ki9"
      }}>{`Gen QR`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/30e69ae884ece61837eb0228b9a881bd/e72e6/collage-layouts.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/30e69ae884ece61837eb0228b9a881bd/2aa01/collage-layouts.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/30e69ae884ece61837eb0228b9a881bd/2aa01/collage-layouts.jpg",
            "alt": "Collage and Layouts",
            "title": "Collage and Layouts",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "collage-and-layouts"
    }}>{`Collage and Layouts`}</h3>
    <p>{`Create collages, grids, and seamless carousels!`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=wil114732"
      }}>{`Collage and Layouts`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/c10fad18db6e57ca368a083772c18fd1/e72e6/wellsaid-voiceover.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/c10fad18db6e57ca368a083772c18fd1/2aa01/wellsaid-voiceover.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/c10fad18db6e57ca368a083772c18fd1/2aa01/wellsaid-voiceover.jpg",
            "alt": "WellSaid Voiceover",
            "title": "WellSaid Voiceover",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "wellsaid-voiceover"
    }}>{`WellSaid Voiceover`}</h3>
    <p>{`Create high-quality AI voiceover for your content.`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=wk2mlg1m4"
      }}>{`WellSaid Voiceover`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/2c3907efda9024a92abee65ba8e1ba40/e72e6/pixel-enhancer.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/2c3907efda9024a92abee65ba8e1ba40/2aa01/pixel-enhancer.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/2c3907efda9024a92abee65ba8e1ba40/2aa01/pixel-enhancer.jpg",
            "alt": "Pixel Enhancer",
            "title": "Pixel Enhancer",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "pixel-enhancer"
    }}>{`Pixel Enhancer`}</h3>
    <p>{`Upscale your images`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w4m1j7314"
      }}>{`Pixel Enhancer`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/e1ae35f7a5614f599d126db5504cabbc/e72e6/artboard-mockups.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/e1ae35f7a5614f599d126db5504cabbc/2aa01/artboard-mockups.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/e1ae35f7a5614f599d126db5504cabbc/2aa01/artboard-mockups.jpg",
            "alt": "Artboard Mockups",
            "title": "Artboard Mockups",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "artboard-mockups"
    }}>{`Artboard Mockups`}</h3>
    <p>{`Create stunning mockups in seconds`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=wl102g614"
      }}>{`Artboard Mockups`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/878104f538b917659a792333b455c9b2/e72e6/wannathis.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/878104f538b917659a792333b455c9b2/2aa01/wannathis.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/878104f538b917659a792333b455c9b2/2aa01/wannathis.jpg",
            "alt": "Wannathis",
            "title": "Wannathis",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "wannathis"
    }}>{`Wannathis`}</h3>
    <p>{`Enhance our content with a powerful 3D library!`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=wl5796m4n"
      }}>{`Wannathis`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/6f89ed1718ddf2112b1ed6df7033555b/e72e6/simple-booklet.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/6f89ed1718ddf2112b1ed6df7033555b/2aa01/simple-booklet.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/6f89ed1718ddf2112b1ed6df7033555b/2aa01/simple-booklet.jpg",
            "alt": "Simple Booklet",
            "title": "Simple Booklet",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "simple-booklet"
    }}>{`Simple Booklet`}</h3>
    <p>{`Present Your Documents as Interactive Flipbooks`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w7nl9lm19"
      }}>{`Simple Booklet`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/4840d621fc0ed39171f652230ed3a750/e72e6/quickqr-code.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/4840d621fc0ed39171f652230ed3a750/2aa01/quickqr-code.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/4840d621fc0ed39171f652230ed3a750/2aa01/quickqr-code.jpg",
            "alt": "Quick QR Code",
            "title": "Quick QR Code",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "quick-qr-code"
    }}>{`Quick QR Code`}</h3>
    <p>{`Quickly generate QR Codes`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=wkmih82l8"
      }}>{`Quick QR Code`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/c1c8abe7b102da879743746b80b88cf4/e72e6/auto-icon.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/c1c8abe7b102da879743746b80b88cf4/2aa01/auto-icon.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/c1c8abe7b102da879743746b80b88cf4/2aa01/auto-icon.jpg",
            "alt": "Auto Icon",
            "title": "Auto Icon",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "auto-icon"
    }}>{`Auto Icon`}</h3>
    <p>{`Access over 160k high-quality icons`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w5jihnj56"
      }}>{`Auto Icon`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/b16a3cdf7dcc6bdb4a7c6a5f912dc6d2/e72e6/space-fill.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/b16a3cdf7dcc6bdb4a7c6a5f912dc6d2/2aa01/space-fill.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/b16a3cdf7dcc6bdb4a7c6a5f912dc6d2/2aa01/space-fill.jpg",
            "alt": "Spacefill",
            "title": "Spacefill",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "spacefill"
    }}>{`Spacefill`}</h3>
    <p>{`Makes generative patterns`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w466h1l71"
      }}>{`Spacefill`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      